import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c2c0a08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "top-data" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { MenuOutlined } from "@ant-design/icons-vue";
import {
  businessPage,
  loginOut,
  resetPassword,
  businessCount,
} from "@/api/api";
import { defineAsyncComponent, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import XDialog from "@/components/XDialog.vue";
import { removeToken } from "@/utils/auth";

interface FormState {
  account: string;
  password: string;
  oldPassword: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Accounts',
  setup(__props) {

const XATable = defineAsyncComponent(() => import("../components/XATable.vue"));
const formState = ref<FormState>({
  account: "sys",
  password: "",
  oldPassword: "",
});
const router = useRouter();
const tableData = ref([] as any[]);
const total = ref(0);
const dialogVisible = ref();
const columns = ref([
  {
    title: "更新时间",
    key: "update_time",
    dataIndex: "update_time",
    sorter: true,
    slots: {
      customRender: "updateTime",
    },
  },
  {
    title: "BM",
    key: "business_id",
    dataIndex: "business_id",
    slots: {
      customRender: "businessId",
    },
    sorter: true,
  },
  {
    title: "广告账号",
    key: "accountId",
    dataIndex: "accountId",
    slots: {
      customRender: "accountId",
    },
  },
  {
    title: "单日花费限额",
    key: "amount_cap",
    dataIndex: "amount_cap",
    slots: {
      customRender: "amountCap",
    },
    sorter: true,
  },
  {
    title: "余额",
    key: "amount",
    dataIndex: "amount",
    sorter: true,
  },
  {
    title: "状态",
    key: "account_status",
    dataIndex: "account_status",
    slots: {
      customRender: "accountStatus",
    },
    sorter: true,
  },
]);

const pageNo = ref(1);
const pageSize = ref(1000);
const loading = ref(false);
const ascField = ref("amount");
const ascOrder = ref("asc");
const countData: any = ref({});

onMounted(() => {
  getCountData();
  getDatas();
});

const pageNoChange = (val: number) => {
  pageNo.value = val;
  getDatas();
};
const onShowSizeChange = (current: any, size: number) => {
  pageSize.value = size;
  getDatas();
};

const getDatas = () => {
  const params = {
    pageNo: pageNo.value,
    pageSize: pageSize.value,
    field: ascField.value,
    order: ascOrder.value,
  };
  loading.value = true;
  businessPage(params).then((res) => {
    loading.value = false;
    tableData.value = res.data.records;
  });
};
const editPassword = () => {
  dialogVisible.value = true;
};
const loginOutClick = () => {
  loginOut({}).then((res) => {
    router.replace("/");
    removeToken();
  });
};
const confirm = () => {
  resetPassword(formState.value).then((res) => {
    if (res.code === "200") {
      loginOutClick();
    }
  });
};
const onHandleChange = (params: any) => {
  console.log(params.pagination, params.filters, params.sorter, params.extra);
  ascField.value = params.sorter.field;
  ascOrder.value =
    params.sorter.order === "ascend"
      ? "asc"
      : params.sorter.order === "descend"
      ? "desc"
      : "";
  getDatas();
};
const getCountData = () => {
  businessCount({}).then((res) => {
    console.log(res);
    countData.value = res.data;
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_dropdown, {
          trigger: ['click'],
          class: "all"
        }, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, {
                  key: "1",
                  onClick: editPassword
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 修改密码 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, {
                  key: "2",
                  onClick: loginOutClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 退出登录 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_button, null, {
              icon: _withCtx(() => [
                _createVNode(_unref(MenuOutlined))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createTextVNode(" BM账户个数："),
        _createElementVNode("span", null, _toDisplayString(countData.value.businessNumber ? countData.value.businessNumber : 0), 1)
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" 广告账户数："),
        _createElementVNode("span", null, _toDisplayString(countData.value.accountNumber ? countData.value.accountNumber : 0), 1)
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" 累计余额($)："),
        _createElementVNode("span", null, _toDisplayString(countData.value.amountsUsd ? countData.value.amountsUsd : 0), 1)
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" 累计余额(₦)："),
        _createElementVNode("span", null, _toDisplayString(countData.value.amountsNGN ? countData.value.amountsNGN : 0), 1)
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" 使用中："),
        _createElementVNode("span", null, _toDisplayString(countData.value.status1 ? countData.value.status1 : 0), 1)
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" 已停用："),
        _createElementVNode("span", null, _toDisplayString(countData.value.status2 ? countData.value.status2 : 0), 1)
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" 已关闭："),
        _createElementVNode("span", null, _toDisplayString(countData.value.status101 ? countData.value.status101 : 0), 1)
      ])
    ]),
    _createVNode(_unref(XATable), {
      columns: columns.value,
      dataSource: tableData.value,
      scroll: { x: 1500 },
      loading: loading.value,
      onMyChange: onHandleChange
    }, {
      accountId: _withCtx(({ scope }) => [
        _createTextVNode(_toDisplayString(scope.record.accountId) + " ", 1),
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(scope.record.accountName), 1)
      ]),
      updateTime: _withCtx(({ scope }) => [
        _createTextVNode(_toDisplayString(scope.record.updateTime), 1)
      ]),
      businessId: _withCtx(({ scope }) => [
        _createTextVNode(_toDisplayString(scope.record.businessId), 1),
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(scope.record.businessName), 1)
      ]),
      amountCap: _withCtx(({ scope }) => [
        _createTextVNode(_toDisplayString(scope.record.amountCap), 1)
      ]),
      accountStatus: _withCtx(({ scope }) => [
        (scope.record.accountStatus === 1)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              color: "green"
            }, {
              default: _withCtx(() => [
                _createTextVNode("使用中")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (scope.record.accountStatus === 2)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              color: "red"
            }, {
              default: _withCtx(() => [
                _createTextVNode("已停用")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (scope.record.accountStatus === 3)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 2,
              color: "orange"
            }, {
              default: _withCtx(() => [
                _createTextVNode("已欠费")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (scope.record.accountStatus === 101)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 3,
              color: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("已关闭")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "dataSource", "loading"]),
    _createVNode(_component_a_pagination, {
      current: pageNo.value,
      "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((pageNo).value = $event)),
      pageSize: pageSize.value,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
      onChange: pageNoChange,
      total: total.value,
      "show-size-changer": "",
      onShowSizeChange: onShowSizeChange,
      style: {"margin-top":"5px","padding-bottom":"10px","margin-left":"10px"}
    }, null, 8, ["current", "pageSize", "total"]),
    _createVNode(XDialog, {
      title: "修改密码",
      visible: dialogVisible.value,
      onConfirm: confirm,
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (dialogVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: formState.value,
          name: "basic",
          "label-col": { span: 6 },
          "wrapper-col": { span: 18 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "用户名",
              name: "account",
              rules: [{ required: false, message: '请输入用户名!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  disabled: "",
                  value: formState.value.account,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.value.account) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "旧密码",
              name: "oldPassword",
              rules: [{ required: true, message: '请输入旧密码!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: formState.value.oldPassword,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formState.value.oldPassword) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "新密码",
              name: "password",
              rules: [{ required: true, message: '请输入新密码!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: formState.value.password,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formState.value.password) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})